module.exports = __webpack_public_path__ + "media/svg/calendar_note-5cacb6a3.svg";